export default {
	"fileUploadComp": {
		"downloadZip": "打包下载"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/components/FileUploadComp/FileUploadComp.js